import { useEffect, useState } from "react";
import { SvgIcon } from "../../chat-list/ChatAvatar.tsx";
import { icons } from "../icons.ts";
import { cancelRecording, finishRecording, formatDuration } from "../recording.ts";

type RecordingComposerProps = {
  onRecordingChange: (recording: boolean) => void;
};

export function RecordingComposer({ onRecordingChange }: RecordingComposerProps) {
  return (
    <footer className="wa-composer wa-composer-recording">
      <button
        className="wa-icon-btn wa-cancel-rec"
        type="button"
        title="Cancelar gravacao"
        aria-label="Cancelar gravacao"
        onClick={() => {
          cancelRecording();
          onRecordingChange(false);
        }}
      >
        <SvgIcon svg={icons.trash} />
      </button>
      <div className="wa-rec-indicator">
        <span className="wa-rec-dot" />
        <RecordingTimer />
        <span className="wa-rec-bars" aria-hidden="true">
          <span /><span /><span /><span /><span /><span /><span /><span /><span /><span />
        </span>
        <span className="wa-rec-hint">Toque para enviar ou cancelar</span>
      </div>
      <button
        className="wa-icon-btn wa-send wa-send-rec"
        type="button"
        title="Enviar audio"
        aria-label="Enviar audio"
        onClick={() => {
          finishRecording();
          onRecordingChange(false);
        }}
      >
        <SvgIcon svg={icons.send} />
      </button>
    </footer>
  );
}

function RecordingTimer() {
  const [start] = useState(() => Date.now());
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), 250);
    return () => window.clearInterval(id);
  }, []);
  return <span className="wa-rec-timer">{formatDuration((now - start) / 1000)}</span>;
}
